<app-navbar></app-navbar>
<section>
  <div class="container">
    <div class="row">
      <div class='card m-5'>
        <div class='card-body'>
          <div class="col-md-12">
            <h1 class="custom-title mt-3">Chairman's Message</h1>
            <div class="custom-image">
              <img src="assets/img/school/messages/3.jpg" alt="Image" class="img-fluid" style="max-width: 100%;">
            </div>
            <div class="custom-text mt-3">
              <p>Proyash-Chattogram started her journey in 2006, fueled by the motto "Special Children, Special Rights."
                This institution
                is working relentlessly and efficiently for children with special needs. Children with special talents
                are performing
                successfully in various fields like formal education, sports, drawing, dancing, singing, computer
                skills, etc. Their
                various activities have been highlighted in the intellectual, mental, and physical development of
                special children with
                the aim of increasing social awareness and the conviction to move forward. <br> <br>
                The motivation and right-directional efforts of the Area Chief Patron and Assistant Patron have
                accelerated the pace of
                the development of the Proyash-Chattogram. Qualified leadership and guidance of the Board of Directors,
                spontaneous
                service, and loving behavior of teachers and staff are turning the development of the children of this
                institution into
                a successful venture. We always hope that the young special children of this institution will one day be
                able to move
                forward in the mainstream of society on an equal footing with the typical children.
              </p>
              <br>
              <br>
              <p class="custom-bold">Colonel Enamul Islam, psc, PhD</p>
              <p>Colonel Admin, Area Headquarters Chattogram Area and</p>
              <p>Chairman Proyash-Chattogram</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>